// 柱状图数据处理通用 - 区域内柱子是一种颜色，区域外柱子是一种颜色
function deal_bar_chart_1(target_data) {
	// 区域范围
	let markArea_range = target_data.range || [];
	if (markArea_range.length != 2) {
		markArea_range = [];
	}
	// X 轴数据
	let xAxis_data = target_data.xaxis || [];
	let special_color_x_index_begin = -1; // 区间范围特殊处理，区分柱子颜色
	let special_color_x_index_end = -1;
	if (markArea_range.length == 2) {
		let markArea_range_1 = markArea_range[0];
		let markArea_range_2 = markArea_range[1];
		if (xAxis_data.indexOf(markArea_range_1) != -1 && xAxis_data.indexOf(markArea_range_2) != -1) { // 存在区间范围
			if (xAxis_data.indexOf(markArea_range_1) > xAxis_data.indexOf(markArea_range_2)) {
				special_color_x_index_begin = xAxis_data.indexOf(markArea_range_2);
				special_color_x_index_end = xAxis_data.indexOf(markArea_range_1);
			} else {
				special_color_x_index_begin = xAxis_data.indexOf(markArea_range_1);
				special_color_x_index_end = xAxis_data.indexOf(markArea_range_2);
			}
		}
	}
	for (let r = 0; r < markArea_range.length; r++) {
		let item = markArea_range[r];
		if (xAxis_data.indexOf(item) == -1) {
			markArea_range = [];
		}
	}
	// Y 轴数据
	let series_data = [];
	let temp_series_data = target_data.data || []; // 区间范围特殊处理，区分柱子颜色
	if (special_color_x_index_begin > 0 || special_color_x_index_end > 0) {
		for (let r = 0; r < temp_series_data.length; r++) {
			let item = temp_series_data[r];
			if (r < special_color_x_index_begin || r > special_color_x_index_end) {
				series_data.push(item);
			} else {
				series_data.push({
					value: item,
					itemStyle: {
						normal: {
							color: '#5F64E7'
						},
					}
				});
			}
		}
	} else {
		series_data = temp_series_data;
	}
	return {
		'xAxis_data': xAxis_data,
		'series_data': series_data,
		'markArea_range': markArea_range
	}
}

// 柱状图数据处理通用 - 柱子是一种颜色
function deal_bar_chart_2(target_data) {
	// 区域范围
	let markArea_range = target_data.range || [];
	if (markArea_range.length != 2) {
		markArea_range = [];
	}
	// X 轴数据
	let xAxis_data = target_data.xaxis || [];
	let special_color_x_index_begin = -1; // 区间范围特殊处理，区分柱子颜色
	let special_color_x_index_end = -1;
	if (markArea_range.length == 2) {
		let markArea_range_1 = markArea_range[0];
		let markArea_range_2 = markArea_range[1];
		if (xAxis_data.indexOf(markArea_range_1) != -1 && xAxis_data.indexOf(markArea_range_2) != -1) { // 存在区间范围
			if (xAxis_data.indexOf(markArea_range_1) > xAxis_data.indexOf(markArea_range_2)) {
				special_color_x_index_begin = xAxis_data.indexOf(markArea_range_2);
				special_color_x_index_end = xAxis_data.indexOf(markArea_range_1);
			} else {
				special_color_x_index_begin = xAxis_data.indexOf(markArea_range_1);
				special_color_x_index_end = xAxis_data.indexOf(markArea_range_2);
			}
		}
	}
	for (let r = 0; r < markArea_range.length; r++) {
		let item = markArea_range[r];
		if (xAxis_data.indexOf(item) == -1) {
			markArea_range = [];
		}
	}
	// Y 轴数据
	let series_data = JSON.parse(JSON.stringify(target_data.data));
	return {
		'xAxis_data': xAxis_data,
		'series_data': series_data,
		'markArea_range': markArea_range
	}
}

function deal_law_scatter_chart_data(targetData) {
	let left_data_4 = targetData;
	if (left_data_4) {

		let secretsDailyRoutine_data = left_data_4.data || [];
		// 获取y轴日期
		let scatter_dates = [];
		for (let k = 0; k < secretsDailyRoutine_data.length; k++) {
			// if (k > 3) {

			// } else {
				let item = secretsDailyRoutine_data[k];
				if (item.date) {
					scatter_dates.push(item.date || '');
				}
			// }
		}

		let hours_data = [19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7, 8];
		let times = [];
		let minutes = [];
		for (let i = 0; i < hours_data.length; i++) {
			let needTime;
			let item = hours_data[i];
			for (let j = 0; j <= 59; j++) {
				if (item == 19) {
					if (j >= 30) {
						let tempHours = item > 9 ? item : '0' + item;
						let tempMinutes = j > 9 ? j : '0' + j;
						needTime = tempHours + ':' + tempMinutes;
						times.push(needTime);
						minutes.push(item * 60 + j);
					}
				} else if (item == 8) {
					if (j <= 30) {
						let tempHours = item > 9 ? item : '0' + item;
						let tempMinutes = j > 9 ? j : '0' + j;
						needTime = tempHours + ':' + tempMinutes;
						times.push(needTime);
						minutes.push(item * 60 + j);
					}
				} else {
					let tempHours = item > 9 ? item : '0' + item;
					let tempMinutes = j > 9 ? j : '0' + j;
					needTime = tempHours + ':' + tempMinutes;
					times.push(needTime);
					minutes.push(item * 60 + j);
				}
			}
		}

		// X轴 19:30 - 20:30 时间点集合
		let scatter_xAxis_data = times;
		// y轴 展示的所有日期
		let scatter_yAxis_data = scatter_dates;
		// 点数据集合
		let scatter_series_data_0 = [];
		let scatter_series_data_1 = [];
		let scatter_series_data_2 = [];
		let scatter_series_data_3 = [];

		for (let k = 0; k < secretsDailyRoutine_data.length; k++) {
			// if (k > 3) {

			// } else {
				let item = secretsDailyRoutine_data[k];
				if (item.date) {
					if (item.getBed) scatter_series_data_0.push([item.getBed, item.date]);
					if (item.sleepSt) scatter_series_data_1.push([item.sleepSt, item.date]);
					if (item.sleepEd) scatter_series_data_2.push([item.sleepEd, item.date]);
					if (item.leaveBed) scatter_series_data_3.push([item.leaveBed, item.date]);
				}
			// }
		}
		// 区间范围
		let go_bed_start = left_data_4.highFreTime.getBedSt;
		let go_bed_end = left_data_4.highFreTime.getBedEd;
		let go_sleep_start = left_data_4.highFreTime.sleepStSt;
		let go_sleep_end = left_data_4.highFreTime.sleepStEd;
		let get_sleep_start = left_data_4.highFreTime.sleepEdSt;
		let get_sleep_end = left_data_4.highFreTime.sleepEdEd;
		let get_bed_start = left_data_4.highFreTime.leaveBedSt;
		let get_bed_end = left_data_4.highFreTime.leaveBedEd;
		let scatter_interval_1 = [];
		let scatter_interval_2 = [];
		let scatter_interval_3 = [];
		let scatter_interval_4 = [];

		if (go_bed_start && go_bed_end) {
			scatter_interval_1 = [
				[
					{
						xAxis: go_bed_start
					},
					{
						xAxis: go_bed_end
					}
				],
			]
		}
		if (go_sleep_start && go_sleep_end) {
			scatter_interval_2 = [
				[
					{
						xAxis: go_sleep_start
					},
					{
						xAxis: go_sleep_end
					}
				],
			]
		}
		if (get_sleep_start && get_sleep_end) {
			scatter_interval_3 = [
				[
					{
						xAxis: get_sleep_start
					},
					{
						xAxis: get_sleep_end
					}
				],
			]
		}
		if (get_bed_start && get_bed_end) {
			scatter_interval_4 = [
				[
					{
						xAxis: get_bed_start
					},
					{
						xAxis: get_bed_end
					}
				],
			]
		}

		let left_chart_data_need_4 = {};
		left_chart_data_need_4.xAxis_data = scatter_xAxis_data;
		left_chart_data_need_4.yAxis_data = scatter_yAxis_data;
		left_chart_data_need_4.series_data0 = scatter_series_data_0;
		left_chart_data_need_4.series_data1 = scatter_series_data_1;
		left_chart_data_need_4.series_data2 = scatter_series_data_2;
		left_chart_data_need_4.series_data3 = scatter_series_data_3;
		left_chart_data_need_4.scatter_interval1 = scatter_interval_1;
		left_chart_data_need_4.scatter_interval2 = scatter_interval_2;
		left_chart_data_need_4.scatter_interval3 = scatter_interval_3;
		left_chart_data_need_4.scatter_interval4 = scatter_interval_4;
		return left_chart_data_need_4;
	}
}

export default {
	deal_bar_chart_1,
	deal_bar_chart_2,
	deal_law_scatter_chart_data
}